import { render, staticRenderFns } from "./listDialog.vue?vue&type=template&id=25d7371a&scoped=true"
import script from "./listDialog.vue?vue&type=script&lang=js"
export * from "./listDialog.vue?vue&type=script&lang=js"
import style0 from "./listDialog.vue?vue&type=style&index=0&id=25d7371a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d7371a",
  null
  
)

export default component.exports